require('babel-polyfill');
import 'es6-object-assign';
import { sync } from 'vuex-router-sync';
import Vue from 'vue';
import Vuebar from 'vuebar';
import App from './App.vue';
import router from './router';
import store from './store';
import { ObserveVisibility } from 'vue-observe-visibility';

require('es6-object-assign').polyfill();
var obj = Object.assign({}, { foo: 'bar' });
console.log(obj);

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);

Vue.directive('observe-visibility', ObserveVisibility);
Vue.use(Vuebar);
sync(store, router);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
